<template>
  <div class="leaderboards-container" :style="{
    'background-image': `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})`,
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }">
    <h2 class="title" :style="{'color': gc.main_color}" v-if="cc.title">
      {{cc.title}}
      <div class="bottom-divider" :style="{'background-color': gc.main_color}"></div>
    </h2>
    <div class="leaderboards rank-list">
      <div class="rank-header" :style="{'color': gc.main_color}">
        <div class="title-left">
          <span class="top-title">排名</span>
          <span class="user-title">用户</span>
        </div>
        <span class="exp-title">经验值</span>
      </div>
      <template v-if="leaderboards && leaderboards.length > 0">
        <div class="rank-item" v-for="(item, index) in leaderboards" :key="item.heybox_id" @click="openUserPage(item)">
          <div class="mask" v-if="index == user_rank" :style="{'background-color': hexToRgba(gc.main_color, .08)}"></div>
          <div class="item-left">
            <div class="top3" v-if="index < 3" :style="`background-image:url(${top3Icons[index].icon})`"></div>
            <span class="rank" v-else :style="{'color': gc.main_color}">{{index + 1}}</span>
            <div class="avatar">
              <img :src="item.avatar" alt="">
            </div>
          </div>
          <div class="item-right">
            <span class="username" :style="{'color': gc.main_color}">{{`${item.username}${index == user_rank ? '（我）' : ''}`}}</span>
            <div class="exp" :style="{'color': gc.main_color}">
              <span>{{item.count}}</span>
              <span>Exp</span>
              </div>
          </div>
        </div>
        <div class="rank-item" @click="openUserPage(querys)" v-if="user_rank > leaderboards.length - 1 || user_rank == -1">
          <div class="mask" :style="{'background-color': hexToRgba(gc.main_color, .08)}"></div>
          <div class="item-left">
            <span class="rank" :style="{'visibility': 'hidden'}">{{user_rank + 1}}</span>
            <div class="avatar">
              <img :src="user_info.avatar" alt="">
            </div>
          </div>
          <div class="item-right">
            <span class="username" :style="{'color': gc.main_color}">{{user_info.username}}（我）</span>
            <div class="exp" :style="{'color': gc.main_color}">
              <span>{{user_info.score_count}}</span>
              <span>Exp</span>
              </div>
          </div>
        </div>
      </template>
      <div class="no-data" v-else>
        <no-data :color="gc.main_color" desc="暂无排名"/>
      </div>
      <div class="more" @click="seeMore" v-if="showMore">
        <div :style="{'color': gc.main_color}">更多排名</div>
        <svg width="12" height="5" viewBox="0 0 12 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.8" d="M6.14641 4.84961L12 -0.000132084L0 -0.000132084L6.14641 4.84961Z" :fill="gc.main_color"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
export default {
  mixins: [ComponentCommonMixin],
  computed: {
    leaderboards () {
      return this.showMore ? this.cd.leaderboards.map(item => item).splice(0, 5) : this.cd.leaderboards
    },
    user_rank () {
      return this.cd.leaderboards.map(item => '' + item.heybox_id).indexOf(this.querys.heybox_id)
    },
    user_info () {
      return {
        username: this.gd.user_info.username,
        avatar: this.gd.user_info.avatar,
        score_count: this.gd.score_count
      }
    }
  },
  mounted () {
    if (this.cd.leaderboards.length > 4) {
      this.showMore = true
    }
  },
  data () {
    return {
      showMore: false,
      top3Icons: [
        {
          icon: 'https://imgheybox.max-c.com/oa/2021/09/29/c64199fd26c83afd600859d9d818bf7a.png',
        },
        {
          icon:'https://imgheybox.max-c.com/oa/2021/09/29/f07762f2be7718e6e0c947ca37e5ca8e.png',
        },
        {
          icon: 'https://imgheybox.max-c.com/oa/2021/09/29/a308743cbae021f9570aaa2b490eb6ee.png',
        },
      ],
    }
  },
  mounted () {
    if (this.cd.leaderboards.length > 4) {
      this.showMore = true
    }
  },
  methods: {
    openUserPage (user) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      var id = user.heybox_id || user.userid || user.user_id
      utils.executeProtocol({
        protocol_type: 'openUser',
        user_id: id
      })
    },
    seeMore () {
      this.showMore = !this.showMore
    }
  }
}
</script>

<style lang="less" scoped>
.leaderboards-container {
  background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
  background-repeat: no-repeat;
  background-position: center top, center center, center bottom;
  margin: 32px 14px 0;
  padding: 14px 18px 20px 14px;
  .title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    padding-bottom: 10px;
    position: relative;
    .bottom-divider {
      position: absolute;
      bottom: 0;
      left: calc(50% + 2px);
      transform: translateX(-50%);
      width: calc(100% - 4px);
      height: .5px;
      opacity: .3;
    }
  }
  .rank-list {
    min-height: 230px;
    position: relative;
    .rank-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;
      margin: 0 auto;
      font: 11px/15px PingFang SC;
      .title-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 24%;
        .top-title {
          opacity: .6;
          padding-left: 4px;
        }
        .user-title {
          opacity: .6;
          padding-right: 2px;
        }
      }
      .exp-title {
        flex: 1;
        text-align: right;
        opacity: .6;
      }
    }
    .rank-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
      position: relative;
      .mask {
        position: absolute;
        left: -14px;
        top: 0;
        height: 100%;
        width: calc(100vw - 32px);
      }
      .item-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 24%;
        .top3 {
          width: 30px;
          height: 30px;
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
        .rank {
          width: 30px;
          text-align: center;
          line-height: 30px;
          font: 700 13px/15px Helvetica;
          color: #AF6335;
        }
        .avatar {
          width: 26px;
          height: 26px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }
      }
      .item-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 18px;
        .username {
          font: 13px/18px PingFang SC;
          color: #A45920;
        }
        .exp {
          color: #A45920;
          span:nth-child(1) {
            font: 14px/17px ALIBABA Font;
          }
          span:nth-child(2) {
            font: 12px/14px Helvetica;
            padding-left: 2px;
          }
        }
      }
    }
    .no-data {
      position: relative;
      top: 20px;
    }
  }
  .more {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 6px;
    div {
      font: 12px/17px PingFang SC;
      opacity: 0.8;
    }
    svg {
      margin-left: 3px;
    }
  }
}
</style>